<ion-content class="theme-{{userService.theme}}">
    <ion-header class="absolute">
        <app-header [backRoute]="getBackRoute()"></app-header>
    </ion-header>

    <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]>
    </div>

    <div class="shadow-container">
        <div #firstBar></div>
        <div class="coach-journey-content">
            <ion-grid *ngIf="report === null">
                <ion-row>
                    <ion-col size="12">
                        <h1 class="my-color-blue">{{ '__COACHING_JOURNEY_LEARNER_TITLE__' | translate }}</h1>
                        <ion-skeleton-text animated style="height: 1rem;margin-bottom: 0.5rem;"></ion-skeleton-text>
                        <ion-skeleton-text animated style="height: 1rem;margin-bottom: 0.5rem;"></ion-skeleton-text>
                        <ion-skeleton-text animated style="height: 1rem;margin-bottom: 0.5rem;"></ion-skeleton-text>
                        <ion-skeleton-text animated style="height: 1rem;margin-bottom: 0.5rem;"></ion-skeleton-text>
                        <ion-skeleton-text animated style="height: 1rem;margin-bottom: 0.5rem;"></ion-skeleton-text>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <ion-grid id="introduction" *ngIf="report !== null">
                <ion-row>
                    <ion-col *ngIf="isLearner()" size="12" size-sm="8">
                        <h1 class="my-color-blue">{{ '__COACHING_JOURNEY_LEARNER_TITLE__' | translate }}</h1>
                        <p>{{ '__COACHING_JOURNEY_LEARNER_CONTENT__' | translate }}</p>
                        <div class="note">
                            <ion-text color="danger"><b>{{ '__COACHING_JOURNEY_COACH_NOTES_TITLE__' | translate }}: </b></ion-text>
                            <span>{{ '__COACHING_JOURNEY_LEARNER_NOTES__' | translate }}</span>
                        </div>
                    </ion-col>
                    <ion-col *ngIf="isManager()" size="12" size-md="8">
                        <h1 class="my-color-blue">{{ '__COACHING_JOURNEY_MANAGER_TITLE__' | translate }}</h1>
                        <p>{{ '__COACHING_JOURNEY_MANAGER_CONTENT__' | translate }}</p>
                        <div class="note">
                            <ion-text color="danger"><b>{{ '__COACHING_JOURNEY_COACH_NOTES_TITLE__' | translate }}: </b></ion-text>
                            <span>{{ '__COACHING_JOURNEY_MANAGER_NOTES__' | translate }}</span>
                        </div>
                    </ion-col>
                    <ion-col *ngIf="isCoach()" size="12" size-md="8">
                        <h1 class="my-color-blue"><img class="profile-photo" *ngIf="report.delegate.avatar_url !== null" [src]="report.delegate.avatar_url"/><div class="profile-name"> <strong>{{report.delegate.full_name}}</strong> {{ '__COACHING_JOURNEY_COACH_TITLE__' | translate }}</div></h1>
                        <p>{{ "__COACHING_JOURNEY_COACH_CONTENT__" | translate : {
                            first_name: report.delegate.first_name,
                            company: report.delegate.company_name,
                            coaching_journey: report.delegate.coaching_journey_name
                        } }}</p>
                        <div class="note">
                            <ion-text color="danger"><b>{{ '__COACHING_JOURNEY_COACH_NOTES_TITLE__' | translate }}: </b></ion-text>
                            <span>{{ '__COACHING_JOURNEY_COACH_NOTES__' | translate }}</span>
                        </div>
                    </ion-col>
                    <ion-col size="4" size-md="1.5" class="ion-hide-md-down">
                        <!-- <a class="white-btn right">
                            <ion-icon name="download"></ion-icon>
                        </a> -->
                        <button class="white-btn right" *ngIf="false && goalsNumber > 0">
                            <ion-icon name="download-outline"></ion-icon>
                        </button>
                    </ion-col>
                    <ion-col size="12" size-md="2.5" size-sm="4">
                        <div class="progress-mark">
                            <div class="circle">
                                <div class="lbl">{{ '__COACHING_JOURNEY_PROGRESS__' | translate }}</div>
                                <div class="inner" [ngClass]="{disabled: goalsNumber === 0, 'primary-bg-color': goalsNumber > 0}">
                                    {{ report !== null ? report?.progress : '0' }}%
                                </div>
                            </div>
                        </div>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <div class="language-dropdown-wrapper" *ngIf="report && isLearner()">
                <div class="language-dropdown">
                    <div class="language-dropdown-title">{{'__COACHING_JOURNEY_CHOOSE_LANGUAGE__' | translate}}</div>
                    <ng-select class="coach-dropdown"
                               [items]="report.coaching_journey_delegate_languages.value"
                               [ngModel]="'__COACHING_JOURNEY_SELECT_ONE_OR_MORE__' | translate"
                               [notFoundText]="'__NG_SELECT_NO_ITEMS_FOUND__' | translate"
                               [searchable]="false"
                               [clearable]="false">

                        <ng-template ng-option-tmp let-item="item" style="pointer-events: none;">
                            <div class="label" (click)="$event.stopPropagation()">
                                <span style="color: black;">{{ item.title }}</span>
                                <input type="checkbox"
                                       style="width: 1.5rem; height: 1.5rem;"
                                       [(ngModel)]="item.status.value"
                                       (click)="$event.stopPropagation()"
                                       (ngModelChange)="onFormChange($event)">
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <div class="language-dropdown">
                    <div class="language-dropdown-title">{{'__COACHING_JOURNEY_CHOOSE_LOCATION__' | translate}}</div>
                    <ng-select class="coach-dropdown"
                               [items]="report.coaching_journey_delegate_locations.value"
                               [ngModel]="'__COACHING_JOURNEY_SELECT_ONE_OR_MORE__' | translate"
                               [notFoundText]="'__NG_SELECT_NO_ITEMS_FOUND__' | translate"
                               [searchable]="false"
                               [clearable]="false">

                        <ng-template ng-option-tmp let-item="item" style="pointer-events: none;">
                            <div class="label" (click)="$event.stopPropagation()">
                                <span style="color: black;">{{ item.title }}</span>
                                <input type="checkbox"
                                       style="width: 1.5rem; height: 1.5rem;"
                                       [(ngModel)]="item.status.value"
                                       (click)="$event.stopPropagation()"
                                       (ngModelChange)="onFormChange($event)">
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <form (ngSubmit)="onSubmit()" #form="ngForm" *ngIf="report !== null">
            <app-coach-dropdown
                [title]="(goalsNumber === 0 ? '__COACHING_JOURNEY_GOALS_TITLE1__' : '__COACHING_JOURNEY_GOALS_TITLE2__') | translate"
                [status]="isFirst"
                (onBarClick)="onAccordionClick($event, 'first')"
            >
                <div class="ion-padding" slot="content">
                    <div class="show-completed">
                        <div class="notifications">
                            <div class="text">{{ "__COACH_SHOW_COMPLETED__" | translate }}</div>
                            <ion-toggle class="black-toggle"
                              [attr.data-label-on]="'__ION_TOGGLE_YES__' | translate"
                              [attr.data-label-off]="'__ION_TOGGLE_NO__' | translate"
                              [checked]="isShowCompletedGoals"
                              (ionChange)="isShowCompletedGoals = !isShowCompletedGoals"
                              mode="ios"></ion-toggle>
                        </div>
                    </div>
                    <div *ngFor="let goal of report.goals.value | filter : 'status' : false : isShowCompletedGoals ? 'ignore' : 'equals'; let i = index"
                         class="goal-item">
                        <ion-grid style="padding: 0">
                            <ion-row>
                                <ion-col size="8" size-sm="8" size-xs="12">
                                    <ion-label
                                        class="coach-label">{{ '__COACHING_JOURNEY_GOALS_QUESTIONS_TITLE__' | translate }}
                                        <ion-text *ngIf="goal.framework_template_question_id.options.required" color="danger"><b>*</b></ion-text>
                                    </ion-label>
                                    <ng-select class="coach-dropdown" name="{{'coach-question-'+goal.id}}"
                                               [(ngModel)]="goal.framework_template_question_id.value"
                                               (ngModelChange)="onFormChange($event)"
                                               [required]="goal.framework_template_question_id.options.required"
                                               [disabled]="goal.framework_template_question_id.options.read_only"
                                               [searchable]="false" [clearable]="false">
                                        <ng-option [value]="0">{{'__COACHING_JOURNEY_PLEASE_SELECT__' | translate}}</ng-option>
                                        <ng-option
                                            *ngFor="let item of report.framework_template_questions"
                                            [value]="item.id">{{ item.title | translate }}
                                        </ng-option>
                                    </ng-select>
                                </ion-col>
                                <ion-col size="4" size-sm="4" size-xs="12">
                                    <app-percent-range
                                        label="{{'__COACHING_JOURNEY_PROGRESS__' | translate}}:"
                                        [(percent)]="goal.progress.value"
                                        (percentChange)="onProgressChange($event, goal)"
                                        [disabled]="goal.progress.options.read_only"></app-percent-range>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                        <ion-row>
                            <ion-col size="12" [attr.size-sm]="isManager() ? 10 : 6">
                                <div class="goal-text">
                                    <div class="goal-label">{{ '__COACHING_JOURNEY_GOALS_NOTES__' | translate }}:
                                        <ion-text *ngIf="goal.goal.options.required" color="danger"><b>*</b></ion-text>
                                    </div>
                                    <textarea class="goal-textarea"
                                              [(ngModel)]="goal.goal.value"
                                              (ngModelChange)="onFormChange($event)"
                                              [required]="goal.goal.options.required"
                                              [disabled]="goal.goal.options.read_only"
                                              name="{{'coach-text-'+goal.id}}">
                                    </textarea>
                                    <div class="goal-text-date">
                                        <div class="goal-date">
                                            {{ goal.updated_at | amDateFormat : 'DD / MM / YYYY' }}
                                        </div>
                                        <div class="goal-date-mark">
                                            {{ '__COACHING_JOURNEY_GOALS_LAST_SAVE__' | translate }}:
                                        </div>
                                    </div>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-sm="4" *ngIf="!isManager()">
                                <div class="goal-text">
                                    <div class="goal-label">{{ '__COACHING_JOURNEY_GOALS_COMMENTS__' | translate }}:
                                        <ion-text *ngIf="goal.comment.options.required" color="danger"><b>*</b></ion-text>
                                    </div>
                                    <textarea class="goal-textarea"
                                              [(ngModel)]="goal.comment.value"
                                              (ngModelChange)="onFormChange($event)"
                                              [required]="goal.comment.options.required"
                                              [disabled]="goal.comment.options.read_only"
                                              name="{{'coach-comments-'+goal.id}}">
                                    </textarea>
                                    <div class="goal-text-date">
                                        <div class="goal-date">
                                            {{ goal.commented_at | amDateFormat : 'DD / MM / YYYY' }}
                                        </div>
                                        <div class="goal-date-mark">
                                            {{ '__COACHING_JOURNEY_GOALS_LAST_SAVE__' | translate }}:
                                        </div>
                                    </div>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-sm="2" class="goal-btn-group">
                                <div class="goal-btn">
                                    <img
                                        src="assets/img/{{ goal.status ? 'tick-large-icon-active.svg' : 'tick-large-icon.svg' }}"
                                        alt="Goal Status Change"
                                        (click)="onGoalStatusChange(goal, goal.status)">
                                </div>
                                <div class="goal-btn">
                                    <img (click)="onRemoveGoal(i, goal)"
                                         *ngIf="goal.goal.options.read_only === false"
                                         class="touch-eff-radius"
                                         src="assets/img/trash-icon.svg"
                                         alt="">
                                </div>
                            </ion-col>
                        </ion-row>
                    </div>
                    <div class="goal-btn">
                        <app-inline-svg
                            *ngIf="report.goals.options.read_only === false && (report.goals.value | filter : 'id' : 0).length === 0"
                            (click)="addGoal()"
                            [cssClass]="'touch-eff-radius'"
                            style="margin: auto; width: 4rem;"
                            [file]="'assets/img/plus-big.svg'"></app-inline-svg>
                    </div>
                </div>
            </app-coach-dropdown>
            </form>
            <div #secondBar></div>
            <app-coach-dropdown
                *ngIf="isLearner()"
                [status]="isSecond"
                [title]="getSecondTitle()"
                [disabled]="goalsNumber === 0 || !report || report.coaching_info.remaining === 0"
                [ngClass]="{disabled: goalsNumber === 0 || !report || report.coaching_info.remaining === 0}"
                [isButton]="report && !!report.coach && goalsNumber > 0"
                [isButtonDisabled]="report && report.coaching_info.remaining === 0"
                (onButtonClick)="chooseNewCoach()"
                (onBarClick)="onAccordionClick($event, 'second')"
            >
                <div class="ion-padding" slot="content" *ngIf="isSecond">
                    <app-coach-list *ngIf="secondAccordionType === 'list'"
                        (gotoCalendarEvent)="templateCoachId = $event; secondAccordionBack = 'list'; secondAccordionType = 'calendar'"
                        (gotoProfileEvent)="templateCoachId = $event; secondAccordionType = 'profile';"
                        ></app-coach-list>
                    <app-coach-profile  *ngIf="secondAccordionType === 'profile'" [templateCoachId]="templateCoachId"
                        (gotoCalendarEvent)=" secondAccordionBack = 'profile'; secondAccordionType = 'calendar'"
                        (gotoBackEvent)="secondAccordionType = 'list';"
                        ></app-coach-profile>
                    <app-appointment-calendar  *ngIf="secondAccordionType === 'calendar'"
                                               [isBack]="this.report.coaching_info.active === 0 || !this.report.coach || templateCoachId !== this.report.coach.id"
                                               [templateCoachId]="templateCoachId"
                        (gotoBackEvent)="secondAccordionType = secondAccordionBack;"
                        ></app-appointment-calendar>
                </div>
            </app-coach-dropdown>
            <div #thirdBar></div>
            <app-coach-dropdown
                *ngIf="isLearner()"
                [status]="isThird"
                [title]="'__COACHING_JOURNEY_APPOINTMENTS_TITLE__' | translate"
                [disabled]="!report || report.coaching_info.total === 0"
                [ngClass]="{disabled: !report || report.coaching_info.total === 0}"
                (onBarClick)="onAccordionClick($event, 'third')"
            >
                <div class="ion-padding" slot="content" *ngIf="report && report.coaching_info.total > 0 && isThird">
                    <div class="notifications">
                        <div class="text">{{ "__COACH_SHOW_COMPLETED__" | translate }}</div>
                        <ion-toggle class="black-toggle"
                                    [checked]="isShowCompletedAppointments"
                                    (ionChange)="isShowCompletedAppointments = !isShowCompletedAppointments"
                                    [attr.data-label-on]="'__ION_TOGGLE_YES__' | translate"
                                    [attr.data-label-off]="'__ION_TOGGLE_NO__' | translate"
                                    mode="ios"></ion-toggle>
                    </div>
                    <app-appointment-list [isShowCompleted]="isShowCompletedAppointments"></app-appointment-list>
                </div>
            </app-coach-dropdown>
            <app-journey-stages *ngIf="isCoach()" [level]="'coach'" [delegateId]="delegateId"></app-journey-stages>
        </div>
    </div>
</ion-content>
<ion-footer *ngIf="!isSaved" class="swiper-no-swiping">
    <app-footer (saveEvent)="onSubmit()" [backButton]="false" [saveButton]="true" [isSaving]="isSaving"></app-footer>
</ion-footer>
